import { css } from "@emotion/react";
import { Button, Theme } from "@mui/material";
import { useRouter } from "next/router";
import React from "react";

import DatabasePanel from "~/components/common/DatabasePanel";
import { Props } from "~/components/database/page/index/lib";
import { flexRow } from "~/lib/client/design";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";

const PcPage = ({ forms }: Props) => {
  const router = useRouter();
  const logger = useActivityLogger();

  const handleOnClick = async () => {
    if (!logger) return;

    await logger({
      actionName: "click_create_database",
      pageName: "databaseIndex",
    });
    await router.push("/database/create");
  };

  return (
    <main css={rootStyle}>
      <section css={sectionContainerStyle}>
        <div css={titleAreaStyle}>
          <h2 css={titleStyle}>新着のデータベース</h2>
          <Button onClick={handleOnClick} variant="contained" color="primary">
            データベースを作る
          </Button>
        </div>
        <ul css={databaseListStyle}>
          {forms.map((form) => (
            <li key={form.id}>
              <DatabasePanel
                database={{ ...form, postSize: form.responses.length }}
              />
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
};

const rootStyle = css`
  display: flex;
  flex-direction: column;
`;

const titleAreaStyle = css`
  ${flexRow};
  justify-content: space-between;
  padding-right: 2.5rem;
`;

const sectionContainerStyle = css`
  margin-top: 3.563rem;
  padding: 0 28px;
`;

const titleStyle = css`
  display: inline-block;
  font-size: 2rem;
  margin: 0;
`;

const databaseListStyle = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  list-style-type: none;
  padding: 0; // NOTE: reset を行っておかないと変なスタイルになる可能性があるため
  margin: 2.125rem 0 0; // NOTE: reset も同時を行っておかないと変なスタイルになる可能性があるため
`;

const databaseLinkStyle = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  text-decoration: underline;
`;

export default PcPage;
